import React, { useState, useRef } from "react";
import GoogleMapReact from "google-map-react";
import useSupercluster from "use-supercluster";
import "./App.css";
import MapMarkerDetail from "Components/Dashboard/MapMarkerDetail/MapMarkerDetail";
import { CircularProgress } from "@material-ui/core";

const Marker = ({ children }) => children;

export default function GMap(props) {
  const mapRef = useRef();
  const [bounds, setBounds] = useState(null);

  const { data, center, loading, zoomLevel } = props;
  const [zoom, setZoom] = useState(zoomLevel);

  const TotalMarkers = data ? data : [];
  const points = TotalMarkers.map((marker) => ({
    type: "Feature",
    properties: {
      cluster: false,
      markerId: marker.id,
      category: marker.pin_type,
    },
    geometry: {
      type: "Point",
      coordinates: [parseFloat(marker.longitude), parseFloat(marker.latitude)],
    },
    data: marker,
  }));

  const { clusters, supercluster } = useSupercluster({
    points,
    bounds,
    zoom,
    options: { radius: 120, maxZoom: 20 },
  });

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_KEY }}
        defaultCenter={{ lat: 1.38406517, lng: 103.7449238 }}
        center={center}
        defaultZoom={12}
        zoom={zoomLevel}
        yesIWantToUseGoogleMapApiInternals
        onGoogleApiLoaded={({ map }) => {
          mapRef.current = map;
        }}
        onChange={({ zoom, bounds }) => {
          setZoom(zoom);
          setBounds([
            bounds.nw.lng,
            bounds.se.lat,
            bounds.se.lng,
            bounds.nw.lat,
          ]);
        }}
      >
        {loading ? (
          <CircularProgress />
        ) : (
          clusters.map((cluster) => {
            const [longitude, latitude] = cluster.geometry.coordinates;
            const { cluster: isCluster, point_count: pointCount } =
              cluster.properties;

            if (isCluster) {
              return (
                <Marker
                  key={`cluster-${cluster.id}`}
                  lat={latitude}
                  lng={longitude}
                >
                  <div
                    className="cluster-marker"
                    style={{
                      width: `${10 + (pointCount / points.length) * 20}px`,
                      height: `${10 + (pointCount / points.length) * 20}px`,
                    }}
                    onClick={() => {
                      const expansionZoom = Math.min(
                        supercluster.getClusterExpansionZoom(cluster.id),
                        20
                      );
                      mapRef.current.setZoom(expansionZoom);
                      mapRef.current.panTo({ lat: latitude, lng: longitude });
                    }}
                  >
                    {pointCount}
                  </div>
                </Marker>
              );
            }

            return (
              <Marker
                key={`marker-${cluster.properties.markerId}`}
                lat={latitude}
                lng={longitude}
              >
                <button className="marker">
                  <MapMarkerDetail data={cluster.data} showDetails={true} />
                </button>
              </Marker>
            );
          })
        )}
      </GoogleMapReact>
    </div>
  );
}
